// Angular modules
import { Component }         from '@angular/core';

// Ionic modules
import { GoogleAnalytics }   from '@ionic-native/google-analytics';
import { NavController }     from 'ionic-angular';
import { ToastController }   from 'ionic-angular';
import { MenuController }    from 'ionic-angular';
import { ModalController }   from 'ionic-angular';
import { NavParams }         from 'ionic-angular';

// External modules
import { CartService }       from '../../shared/providers/cart-service';
import { AddToCartPage }     from '../add-to-cart/add-to-cart';
import { VacuumCalculation } from './calculation.provider';
import { TranslateService }  from '@ngx-translate/core';

@Component({
  selector    : 'page-calculator-results',
  templateUrl : 'calculator-results.html'
})
export class CalculatorResultsPage
{
  addedToCart : boolean = false;
  calculation : VacuumCalculation;

  constructor(
    public navCtrl     : NavController,
    public params      : NavParams,
    public menuCtrl    : MenuController,
    public toastCtrl   : ToastController,
    public cartService : CartService,
    public modalCtrl   : ModalController,
    public translate   : TranslateService,
    private analytics  : GoogleAnalytics
    )
  {
    this.calculation = params.data;
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Calculator result");
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  closeModal()
  {
    this.navCtrl.pop({animate:false});
  }

  addToCart()
  {
    let profileModal = this.modalCtrl.create(AddToCartPage, this.calculation);
    profileModal.present();
  }

  presentToast(message)
  {
     let toast = this.toastCtrl.create({
       message: message,
       duration: 3000
     });
     toast.present();
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/calculator-results/calculator-results.ts